import CustomisableWidgetEditorSocial from '@intercom/embercom-composer/components/customisable-widget-editor-social';
export default CustomisableWidgetEditorSocial;
